import { faqData } from '@/mocks/homeData';

export default function FAQSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="section-container max-w-4xl">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            常见问题
          </h2>
          <p className="text-sm text-foreground-500 mt-1">关于天狼影院，您想了解的一切</p>
        </div>

        <div className="flex flex-col gap-4">
          {faqData.map((faq, index) => (
            <details
              key={index}
              className="group bg-background-50 border border-background-200 rounded-xl overflow-hidden cursor-pointer"
            >
              <summary className="flex items-center justify-between px-5 py-4 list-none">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 pr-4">
                  {faq.question}
                </h3>
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                  <i className="ri-arrow-down-s-line text-foreground-400 group-open:hidden"></i>
                  <i className="ri-arrow-up-s-line text-foreground-400 hidden group-open:block"></i>
                </div>
              </summary>
              <div className="px-5 pb-4">
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}